(
    function (skyward, $)
    {
        "use strict";

        skyward.taskstatus = skyward.taskstatus || {};

        var requestUrl;
        var pingCount;
        var requestHandle;
        var messageBox;
        var waitingBox;
        var popupHandle;
        var workflowAborted;

        // If you created a status layer prior to initiating asynch status report, you MUST populate layer.statusDataContent before passing layer into this function.
        skyward.taskstatus.beginAsyncStatusReport = function (workflowInstanceID, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            requestUrl = skyward.global.virtualDir + "workflow/workflowinstance/nextview/" + workflowInstanceID;
            pingCount = 0;
            requestHandle = null;
            messageBox = null;
            waitingBox = null;
            popupHandle = null;
            workflowAborted = false;

            return requestStatus(null, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
        };

        var requestStatus = function (deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            $(document.body).addClass("cursor-progress");

            if (popupHandle === null)
            {
                popupHandle = setTimeout(function ()
                {
                    popupHandle = 0;
                }, 1000);
            }

            if (requestHandle)
            {
                clearTimeout(requestHandle);
                requestHandle = null;
            }

            deferred = deferred || $.Deferred();

            $.ajax(requestUrl,
                {
                    type: "POST",
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        requestStatusSuccess(data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
                    },
                    statusCode:
                    {
                        404: function (data)
                        {
                            requestStatus404(data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
                        },
                        500: function ()
                        {
                            abortWorkflow();
                            deferred.reject();
                        }
                    }
                });

            return deferred.promise();
        };

        var requestStatusSuccess = function (data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            $(document.body).removeClass("cursor-progress");

            if (waitingBox)
            {
                waitingBox.close();
            }

            // if the popup isn't open already, prevent it from opening
            if (popupHandle)
            {
                clearTimeout(popupHandle);
            }

            if (messageBox)
            {
                messageBox.close();
            }

            switch (data.workflowStatus)
            {
                case "C":
                    //Completed
                    if (typeof onAllTasksCompleted === "function")
                    {
                        const hasBenchmarkSurvey = data.benchmarkingData !== null &&
                            data.benchmarkingData.redirectToSameWorkflow === false;
                        const postponeRedirect = hasBenchmarkSurvey;

                        const redirectFunction = onAllTasksCompleted(data, postponeRedirect);

                        if (hasBenchmarkSurvey)
                        {
                            processBenchmarkSurvey(data.benchmarkingData, redirectFunction || checkRefresh);
                        }
                        else
                        {
                            checkRefresh();
                        }

                        function checkRefresh()
                        {
                            if (data.refreshScreen || data.additionalValues.RefreshScreen)
                            {
                                var location = skyward.global.addRequiredQuerystringParams(skyward.global.virtualDir + data.referrerURL);
                                window.location.href = location;
                            }
                        }
                    }
                    deferred.resolve();
                    break;
                case "I":
                    //InProgress 
                    if (data.errors)
                    {
                        var workflow = $("#popup" + skyward.window.getCurrentPopupId()).find(".workflow");
                        workflow.find(".toolbar").find(".button.ui-disabled").addClass("dirty").removeClass("ui-disabled");
                        var baseErrorContainer = workflow.find("#baseWorkflowErrorContainer");
                        var container = workflow.find(".workflowContent");
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                    else if (typeof onNextTaskInprogress === 'function')
                    {
                        $.when(onNextTaskInprogress(data)).always(function () { deferred.resolve(); });
                        return;
                    }
                    deferred.resolve();
                    break;
                case "E":
                    // Error
                    abortWorkflow();
                    if (typeof onValidationError === "function")
                    {
                        onValidationError(data);
                    }
                    deferred.resolve();
                    break;
                case "F":
                    // Invalid
                    abortWorkflow();
                    if (typeof onValidationError === "function")
                    {
                        onValidationError(data);
                    }
                    deferred.resolve();
                    break;
                default:
                    deferred.resolve();
                    break;
            }
        };

        var requestStatus404 = async function (jqXHR, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            var timeout = 1000;
            pingCount++;
            if (!$.isEmptyObject(jqXHR) && jqXHR.responseText)
            {
                var statusData = JSON.parse(jqXHR.responseText);
                if (!$.isEmptyObject(statusData) && statusData.message)
                {
                    if (statusData.synchronousLockWaiting)
                    {
                        timeout = 5000;
                        if (!waitingBox)
                        {
                            showWaitMessage(deferred, statusData.taskInstanceID, statusData.message);
                        }
                        else
                        {
                            await waitingBox.content.viewpartHtml(statusData.message);
                            waitingBox.animateModalContents();
                        }
                    }
                    else
                    {
                        if (pingCount >= 54)
                        {
                            timeout = 5000;
                        }
                        else if (pingCount >= 30)
                        {
                            timeout = 2500;
                        }
                        if (waitingBox)
                        {
                            waitingBox.close();
                        }
                        if (!messageBox)
                        {
                            if (!popupHandle)
                            {
                                showStatusMessage(deferred, statusData);
                            }
                        }
                        else
                        {
                            await messageBox.content.viewpartHtml(statusData.message);
                            messageBox.animateModalContents();
                            skyward.controls.toggleVisible(messageBox.footer, statusData.allowAsyncCancel);
                        }
                    }
                }
            }
            requestHandle = setTimeout(function ()
            {
                if (!workflowAborted)
                {
                    requestStatus(deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
                }
            }, timeout);
        };

        var showStatusMessage = function (deferred, statusData)
        {
            if (waitingBox)
            {
                waitingBox.close();
            }

            let deferredBeforeShowContent = $.Deferred();
            let cancelButton = { id: "cancelButton", text: "Cancel", click: () => { voidWorkflowInstanceClick(deferred, statusData.taskInstanceID); }, icon: "Cancel", additionalClasses: "js-cancelProcess" };
            messageBox = skyward.modalLayer.showProcessingDialog(
                "Processing Request",
                statusData.message,
                [cancelButton], // If adding new buttons, be sure to update the footer hide logic, as currently it only expects there to be a cancel button
                {
                    allowNoButtons: true,
                    closeOnClick: false,
                    closeOnEscape: false,
                    forceClose: true,
                    afterClose: function ()
                    {
                        $(document.body).removeClass("cursor-progress");
                        messageBox = null;
                    },
                    beforeShowContentPromise: deferredBeforeShowContent.promise(),
                    width: "550px"
                });
            messageBox.bodyPromise.done(function ()
            {
                // Guards against messageBox already being closed before this async operation completes
                if (messageBox)
                {
                    skyward.controls.toggleVisible(messageBox.footer, statusData.allowAsyncCancel);
                }
                
                deferredBeforeShowContent.resolve();
            });
        };

        var showWaitMessage = function (deferred, taskInstanceID, contents)
        {
            if (messageBox)
            {
                messageBox.close();
            }

            let cancelButton = { id: "cancelButton", text: "Cancel", click: () => { voidWorkflowInstanceClick(deferred, taskInstanceID); }, icon: "Cancel" };
            waitingBox = skyward.modalLayer.showProcessingDialog(
                "Processing Request",
                contents,
                [cancelButton],
                {
                    closeOnClick: false,
                    closeOnEscape: false,
                    afterClose: function ()
                    {
                        $(document.body).removeClass("cursor-progress");
                        waitingBox = null;
                    },
                    width: "550px"
                });
        };

        var voidWorkflowInstanceClick = function (deferred, taskInstanceID)
        {
            $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/cancel/" + taskInstanceID,
                {
                    type: "POST",
                    activityIndicator: { hideGlass: true },
                    success: function (data)
                    {
                        abortWorkflow();
                        deferred.reject();
                        $(document.body).trigger(data.cancelEventName);
                    }
                });
        };

        var abortWorkflow = function ()
        {
            workflowAborted = true;

            if (popupHandle)
            {
                clearTimeout(popupHandle);
            }

            if (requestHandle)
            {
                clearTimeout(requestHandle);
                requestHandle = null;
            }

            if (messageBox)
            {
                messageBox.close();
            }

            if (waitingBox)
            {
                waitingBox.close();
            }

            $("#pendingWorkflows :last-child").remove();
            skyward.workflow.closeWorkflowPopup();
            $(document.body).removeClass("cursor-progress");
        };

        function processBenchmarkSurvey(serverBenchmarkingData, afterSurveyCallback)
        {
            const localBenchmarkingData = {
                WorkflowDescription: serverBenchmarkingData.workflowDescription,
                MessageOverride: serverBenchmarkingData.endOfWorkflowMessage,
                CurrentUserID: serverBenchmarkingData.currentUserID,
                BenchmarkingSurveyID: serverBenchmarkingData.benchmarkingSurveyID,
                UserIDOwner_securityhash: serverBenchmarkingData.userIDOwner_securityhash,
                BenchmarkingSurveyID_securityhash: serverBenchmarkingData.benchmarkingSurveyID_securityhash,
            };

            skyward.benchmarking.showWorkflowSurvey(localBenchmarkingData, afterSurveyCallback);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);
